jQuery(document).ready(function($) {

	var gallery = $('.js-gallery');
	var currentSlide = $('.js-current-slide');

	var controls = {
		prev: $('.js-gallery--prev'),
		next: $('.js-gallery--next')
	}

	gallery.slick({
		arrows: false,
		fade: true
	});

	controls.prev.on('click', function(event) {
		event.preventDefault();
		gallery.slick('slickPrev');
	});

	controls.next.on('click', function(event) {
		event.preventDefault();
		gallery.slick('slickNext');
	});

	gallery.on('beforeChange', function(event, slick, current, next) {
		currentSlide.html(next + 1);
	});

});
